// Added by Sejune Oh on 2019-03-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'
import { AxiosError } from 'axios'

import Rootstore from '../../index'
import DataStorageStoreBase from '../../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface DSConfigIncomingVolumeElementBaseProps {
  id?: string
  dir_path?: string
  dir_credential?: string
  description?: string
  disk_total_size_mib?: number
  disk_used_size_mib?: number
  valid?: 'true' | 'false'
  error?: string
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

export interface DSConfigIncomingVolumeElemenProps extends DSConfigIncomingVolumeElementBaseProps {
  proxy_token?: string
  volume_disk_id?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageConfigIncomingVolumeDiskStore extends DataStorageStoreBase<
  DSConfigIncomingVolumeElemenProps
> {
  element?: DSConfigIncomingVolumeElemenProps
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({
      storeName: 'DS_ConficIncomingVolumeDisk',
      apiSubUrl: 'config/incoming-volumedisk',
      _root: root,
    })
    this.root = root
    makeObservable(this, {
      element: observable,
      setIncomingVolumeDisk: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getIncomingVolumeDiskInfo = async (): Promise<{
    err: AxiosError | Error | undefined
    element?: DSConfigIncomingVolumeElemenProps
  }> => {
    try {
      const element = await super.getSingleWithoutId()
      this.setIncomingVolumeDisk(element)
      return {
        err: undefined,
        element,
      }
    } catch (err) {
      return {
        err,
        element: undefined,
      }
    }
  }

  setIncomingVolumeDisk = (incomingVolumeDisk: DSConfigIncomingVolumeElemenProps) => {
    this.element = incomingVolumeDisk
  }

  updateIncomingVolumeDiskInfo = async (volume_disk_id: string, proxy_token: string) => {
    await super.updateWithoutId({
      volume_disk_id,
      proxy_token,
    })
    return await this.getIncomingVolumeDiskInfo()
  }
}
